import React from 'react';
import { DashboardHeader } from './DashboardHeader';

interface DashboardEmptyStateProps {
  logoImage?: { url: string };
  restaurantName: string;
  firstLetter: string;
  onCreateCampaign: () => void;
}

export const DashboardEmptyState: React.FC<DashboardEmptyStateProps> = ({
  logoImage,
  restaurantName,
  firstLetter,
  onCreateCampaign,
}) => {
  return (
    <div className="">
      <DashboardHeader
        logoImage={logoImage}
        restaurantName={restaurantName}
        firstLetter={firstLetter}
        onCreateCampaign={onCreateCampaign}
      />

      <div className="flex flex-col items-center justify-center min-h-[60vh]">
        <img
          src="/assets/images/emptyCampaign.png"
          alt="No Campaigns"
          className="w-auto h-40 mb-6 object-contain"
        />
        <h2 className="text-2xl font-semibold text-white mb-3">
          No Campaigns Created!
        </h2>
        <p className="text-gray-400 text-center text-sm max-w-md">
          Start creating campaigns to keep your restaurant active and engaging on social media.
        </p>
      </div>
    </div>
  );
};
